/**
 * @typedef {Object} CarnetDetails
 * @property {string} master_id - The master organization ID
 * @property {Date|string} creation_date - Date when the carnet was created
 * @property {boolean} isSoldToParticular - Whether sold to a particular client
 * @property {boolean} isSoldToProfessional - Whether sold to the first client
 * @property {Array<string>} partners_id - Array of partner organization IDs with access
 */

const hasAccessToCarnet = async (orgData, carnetDetails) => {
  if (!orgData || !carnetDetails) return false;
  // if (!(["wmLGIwRMtQD2LLc6nXQf", "se4um6hWlIVKiLxln3gB"].includes(orgData.id) || orgData.partner_type === "expert" && ["wmLGIwRMtQD2LLc6nXQf", "se4um6hWlIVKiLxln3gB"].includes(orgData.master_id))) return false;
  if (orgData.id === carnetDetails?.master_id) return true;
  if (
    carnetDetails.visions &&
    carnetDetails.visions.some((vision) => vision.org_id === orgData.id)
  )
    return true;
  if (
    carnetDetails.partners_id &&
    carnetDetails.partners_id.includes(orgData.id)
  )
    return true;
  return false;
};

const folderHasCarnet = (folder) => {
  if (!folder) return false;
  return folder.carnet_id != null;
};

const canCreateCarnet = (orgData, folder) => {
  if (!orgData || !folder) return false;
  if (
    ["wmLGIwRMtQD2LLc6nXQf", "se4um6hWlIVKiLxln3gB"].includes(orgData.id) ||
    (orgData.partner_type === "expert" &&
      ["wmLGIwRMtQD2LLc6nXQf", "se4um6hWlIVKiLxln3gB"].includes(
        orgData.master_id
      ))
  ) {
    return true;
  }
  return false;
};

/**
 * Fetches carnet details for a specific folder.
 * @param {string} folderId - The folder ID.
 * @param {string} token - The user's auth token.
 * @param {string} prefix - The API base URL.
 * @returns {Promise<Object>} - The response containing carnet details.
 */
const getCarnetDetails = async (folderId, token, prefix) => {
  const url = `${prefix}folders/${folderId}/carnet_details`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return await response.json();
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export {
  hasAccessToCarnet,
  canCreateCarnet,
  folderHasCarnet,
  getCarnetDetails,
};
